import { SxProps, Theme } from '@mui/material';

export const searchModalStyles: Record<string, SxProps<Theme>> = {
  dialog: {
    '& .MuiDialog-container': { alignItems: 'flex-start' },
  },

  paper: {
    mt: '14vh',
    borderRadius: 3,
  },

  searchBox: (theme) => ({
    p: theme.breakpoints.down('sm') ? 1.5 : 2,
  }),

  textFieldInput: {
    backgroundColor: '#f8f8f8',
    borderRadius: 2,
    px: 1,
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
  },

  tabsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    mb: 1,
  },

  resultsContainer: (theme) => ({
    px: theme.breakpoints.down('sm') ? 1.5 : 2,
    pb: theme.breakpoints.down('sm') ? 1.5 : 2,
  }),

  resultsPaper: {
    borderRadius: 1,
    maxHeight: '55vh',
    overflow: 'auto',
  },

  resultRow: {
    display: 'flex',
    gap: 1.5,
    alignItems: 'flex-start',
    px: 1.25,
    py: 1,
    '&:hover': { background: 'rgba(0,0,0,0.03)' },
    cursor: 'pointer',
  },

  resultIcon: {
    flex: '0 0 34px',
    display: 'flex',
    justifyContent: 'center',
    mt: 0.2,
  },

  resultTitle: {
    fontWeight: 400,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  loadingWrapper: {
    display: 'flex',
    justifyContent: 'center',
    py: 4,
  },

  emptyState: {
    py: 3,
    textAlign: 'center',
  },

  infoRow: {
    display: 'flex',
    gap: { xs: 0.5, sm: 1.5, md: 2 },
    alignItems: 'center',
    color: 'text.secondary',
    mt: { xs: 1, md: 0.3 },
    flexWrap: 'wrap',
  },

  infoItem: {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
    minWidth: 0,
    maxWidth: '100%',
  },

  infoText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
